<template>
    <b-container>
        <div v-if="taskList.length > 0">
            <b-row class="pt-2">
                <b-col sm="4" class="mt-2">
                    <b-form-select v-model="perPage" :options="options"></b-form-select>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
                    <b-button variant="link" @click="resetTable()">{{
                        $t("action.reset")
                    }}</b-button>
                </b-col>
                <b-col sm="4" class="mt-2">
                    <div>{{ $t("label.tablesize") }} {{ rows }}</div>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col class="lgTable">
                    <b-table id="taskTable" stacked="lg" bordered :fields="myfields" :items="items" :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc" :per-page="perPage" :current-page="currentPage">
                        <template v-slot:cell(Title)="row">
                            <b-button variant="link" size="sm" @click="setNextPage('TaskBuildingList', row.item)">{{
                                row.item.Title }}</b-button>
                        </template>
                        <template v-slot:cell(details)="row">
                            <b-button variant="danger" size="sm" @click="openModal('deleteTaskGroup', row.item)">{{
                                $t("action.remove")
                            }}</b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <b-row class="pt-4">
                <b-col sm="6" class="mt-2">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                        aria-controls="taskListTable"></b-pagination>
                </b-col>
            </b-row>
        </div>

        <b-modal id="deleteTaskGroup" :title="$t('action.removeTaskEvent')" hide-footer>
            <removeTaskModal :task="rowItem" modalid="deleteTaskGroup" />
        </b-modal>

        <div v-if="spinner" class="text-center">
            <b-spinner style="width: 3rem; height: 3rem" class="spinner" variant="success" label="Spinning"
                disabled="labelStatus"></b-spinner>
        </div>

        <div v-if="error" class="pt-4">
            <b-alert show variant="danger">
                <p>{{ error }}</p>
            </b-alert>
        </div>
    </b-container>
</template>
  
<script>
import axios from "axios";
import { globalF } from "../../Helpers";
import removeTaskModal from "./RemoveTask.vue";

export default {
    mixins: [globalF],
    props: [],
    data() {
        return {
            taskTable: null,
            taskRadio: null,
            success: false,
            error: "",
            spinner: false,
            task: null,
            taskList: [],
            taskListTable: [],
            rawData: [],
            teamsGroup: [],
            teamBuildings: [],
            buildings: [],
            building: null,
            sortBy: "Creation",
            sortDesc: true,
            perPage: 10,
            currentPage: 1,
            search: "",
            options: [
                { value: 10, text: "10" },
                { value: 25, text: "25" },
                { value: 50, text: "50" },
                { value: 100, text: "100" },
            ],
            teamSelect: null,
            existingTeamForBuilding: false,
            newGroupName: "",
            teamPlan: null,
            teamBucket: null,
            memberOf: [],
            rowItem: null,
            infoTaskError: []
        };
    },
    validations() { },
    mounted() {
        this.$root.$on("bv::modal::hide", () => {
            this.getTeamBuildingTaskList();
        });
        this.getTeamBuildingTaskList();
    },
    watch: {},
    computed: {
        user: function () {
            return this.$store.getters.getUser;
        },
        url: function () {
            return this.getUrl();
        },
        rows() {
            return this.items.length;
        },
        items: function () {
            let mydatalist = this.taskList;
            let search = this.search.toLowerCase();

            return mydatalist.filter((p) => {
                let title = p.Title ? p.Title : "";
                let status = p.TaskStatus ? p.TaskStatus : "";
                let creation = p.Creation ? p.Creation : "";
                let displayName = p.DisplayName ? p.DisplayName : "";

                return (
                    title.toString().toLowerCase().includes(search) ||
                    status.toString().toLowerCase().includes(search) ||
                    creation.toLowerCase().includes(search) ||
                    displayName.toLowerCase().includes(search)
                );
            });
        },
        myfields: function () {
            return [
                {
                    key: "Title",
                    sortable: true,
                    label: this.$t("label.taskTitle"),
                },
                {
                    key: "TaskStatus",
                    sortable: true,
                    label: this.$t("label.status")
                },
                {
                    key: "DisplayName",
                    sortable: true,
                    label: this.$t("title.user")
                },
                {
                    key: "Creation",
                    sortable: true,
                    label: this.$t("label.createdDateTime")
                },
                {
                    key: "details",
                    label: this.$t("label.details"),
                    sortable: false,
                },
            ];
        },
    },
    methods: {
        openModal: function (id, value) {
            this.rowItem = value;
            this.$bvModal.show(id);
        },
        getTeamBuildingTaskList() {
            this.spinner = true;
            let urls = this.$store.getters.getUrlsList;
            let url = urls[process.env.VUE_APP_WHERE].json;
            let destination = this.getDestinationByUserRole(this.user.role);

            axios
                .post(
                    url,
                    { request: "getTeamBuildingTaskList", destination: destination },
                    { headers: { "Content-Type": "application/json" } }
                )
                .then((response) => {
                    this.spinner = false;
                    this.teamBuildings = response.data.teamBuildings;
                    this.buildings = response.data.buildings;
                    this.taskList = response.data.taskEvent;
                })
                .catch(() => {
                    this.spinner = false;
                    this.error = this.$t("info.errorgeneric");
                });
        },
        resetTable: function () {
            this.search = "";
        },
        setNextPage(page, rowItem) {
            this.$store.commit('addTaskSelected', rowItem);
            this.$emit("changePage", page);
        },
    },
    components: {
        removeTaskModal
    },
};
</script>
  